import { useActiveProfile } from '@/store/localStorage/useTokenState';
import {
  selectNotificationsMentioned,
  selectNotificationsOwnBlog,
  selectNotificationsPrivate,
  selectNotificationsSmbdElseBlog
} from '@/store/notifications/selectors/selectNotifications';
import {
  selectCommentsGroupedByEntryId,
  selectCommentsWithMentionGroupedByEntryId,
  selectConversationMessagesGroupedByProfileId
} from '@/store/notifications/selectors/selectNotificationsGrouped';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'simplebar';
import 'simplebar/dist/simplebar.min.css';
import { SecondaryButton } from '../../../../components/Shared/Buttons';
import {
  selectCommentedEntriesOwn,
  selectCommentedEntriesSmbdElse,
  selectEntriesWithMention,
  selectProfilesWithPrivateNotification
} from '../../../../store/notifications/selectors/selectNotificationEntries';
import {
  selectOldestMentionedNotificationUrl,
  selectOldestOwnNotificationUrl,
  selectOldestSmbdElseNotificationUrl
} from '../../../../store/notifications/selectors/selectOldestNotificationUrl';
import Accordion from './Accordion';
import GroupedNotificationsForConversation from './notifications/GroupedNotificationsForConversation';
import GroupedNotificationsForEntry from './notifications/GroupedNotificationsForEntry';
import { ResetAllNotifications } from './ResetAllNotifications';
import { SidebarButtonArea } from './styled';

export function NotificationsSidebar() {
  const navigate = useNavigate();
  const { activeProfileId } = useActiveProfile();

  const notificationsOwn = useSelector(state =>
    selectNotificationsOwnBlog(state, { activeProfileId })
  );
  const notificationsSmbdElse = useSelector(state =>
    selectNotificationsSmbdElseBlog(state, { activeProfileId })
  );
  const notificationsMentioned = useSelector(state =>
    selectNotificationsMentioned(state, { activeProfileId })
  );
  const notificationsPrivate = useSelector(state =>
    selectNotificationsPrivate(state, { activeProfileId })
  );

  const entriesOwn = useSelector(state =>
    selectCommentedEntriesOwn(state, { activeProfileId })
  );
  const entriesSmbdElse = useSelector(state =>
    selectCommentedEntriesSmbdElse(state, { activeProfileId })
  );
  const entriesMentioned = useSelector(state =>
    selectEntriesWithMention(state, { activeProfileId })
  );
  const profilesWithPrivateNotification = useSelector(state =>
    selectProfilesWithPrivateNotification(state, { activeProfileId })
  );

  const commentsGroupedByEntryId = useSelector(selectCommentsGroupedByEntryId);
  const commentsWithMentionGroupedByEntryId = useSelector(
    selectCommentsWithMentionGroupedByEntryId
  );
  const messagesGroupedByProfileId = useSelector(
    selectConversationMessagesGroupedByProfileId
  );

  const oldestSmbdElseNotificationUrl = useSelector(state =>
    selectOldestSmbdElseNotificationUrl(state, { activeProfileId })
  );
  const oldestOwnNotificationUrl = useSelector(state =>
    selectOldestOwnNotificationUrl(state, { activeProfileId })
  );
  const oldestMentionedNotificationUrl = useSelector(state =>
    selectOldestMentionedNotificationUrl(state, { activeProfileId })
  );

  return (
    <>
      <div>
        <Accordion
          title="комментарии"
          notificationsCounter={notificationsOwn?.length}
          notificationsLink={oldestOwnNotificationUrl}
          notificationsTitle={'к самому раннему комментарию'}
        >
          <GroupedNotificationsForEntry
            commentsGroupedByEntryId={commentsGroupedByEntryId}
            notifications={notificationsOwn}
            entries={entriesOwn}
          />
        </Accordion>

        <Accordion
          title="дискуссии"
          notificationsCounter={notificationsSmbdElse?.length}
          notificationsLink={oldestSmbdElseNotificationUrl}
          notificationsTitle={'к самому раннему комментарию'}
        >
          <GroupedNotificationsForEntry
            commentsGroupedByEntryId={commentsGroupedByEntryId}
            notifications={notificationsSmbdElse}
            entries={entriesSmbdElse}
          />
        </Accordion>

        <Accordion
          title="упоминания"
          notificationsCounter={notificationsMentioned?.length}
          notificationsLink={oldestMentionedNotificationUrl}
          notificationsTitle={'к самому раннему упоминанию'}
        >
          <GroupedNotificationsForEntry
            commentsGroupedByEntryId={commentsWithMentionGroupedByEntryId}
            notifications={notificationsMentioned}
            entries={entriesMentioned}
          />
        </Accordion>

        <Accordion
          title="разговоры"
          notificationsCounter={notificationsPrivate?.length}
          notificationsLink={null} // No selector for oldestPrivateNotificationUrl in original code
          notificationsTitle={'к самому раннему сообщению'}
        >
          <GroupedNotificationsForConversation
            profiles={profilesWithPrivateNotification}
            notifications={notificationsPrivate}
            messagesGroupedByProfileId={messagesGroupedByProfileId}
          />
          <SidebarButtonArea>
            <SecondaryButton
              onClick={() => navigate('/direct')}
              title="Перейти к разговорам"
            >
              все разговоры
            </SecondaryButton>
          </SidebarButtonArea>
        </Accordion>
      </div>

      <ResetAllNotifications />
    </>
  );
}
